import React, {useMemo} from "react";
import {
  Text,
  StyleSheet, View,
} from "@react-pdf/renderer";

import {
  calculatePdfFontSize,
  calculatePdfHeight,
} from "../../../Utils";
import {FormPrintOptionsType} from "../../../Types";
import {PdfLabelIconType} from "../Types/Pdf";
import * as Icons from "../../../Icons/Components";
import {getAutoTextSize} from "../Config";

export const PdfIcon = ({printOptions, label, colorRed}: { printOptions: FormPrintOptionsType, label: PdfLabelIconType, colorRed: string }) => {
  const styles = StyleSheet.create({
    iconContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: calculatePdfHeight(460, printOptions.size),
    },
    gammeDiscountIcon: {
      textAlign: "center",
      height: calculatePdfHeight(240, printOptions.size),
    },
    gammeDiscountPrecision: {
      fontFamily: "LeagueSpartan",
      fontWeight: "bold",
      color: "black",
      textAlign: "center",
      marginTop: calculatePdfHeight(20, printOptions.size),
      paddingLeft: calculatePdfHeight(15, printOptions.size),
      paddingRight: calculatePdfHeight(15, printOptions.size),
      textTransform: "uppercase",
    }
  });

  const themeIconContainer = useMemo(() => ({
    portrait: {
      height: calculatePdfHeight(460, printOptions.size),
    },
    landscape: {
      height: calculatePdfHeight(260, printOptions.size),
    }
  }), [printOptions.size]);

  // @ts-ignore
  const DiscountIcon = label.icon ? (Icons[label.icon] || null) : null;

  return (
    <View style={{...styles.iconContainer, ...themeIconContainer[printOptions.orientation]}}>
      <View style={styles.gammeDiscountIcon}>
        {DiscountIcon && <DiscountIcon color={colorRed} />}
      </View>

      <Text style={{
        ...styles.gammeDiscountPrecision,
        fontSize: calculatePdfFontSize(getAutoTextSize(label.discountDetail, 60, 18),
          printOptions.size)
      }}>
        {label.discountDetail}
      </Text>
    </View>
  );
};

export default PdfIcon;
